export const RECEIVE_USER_IDENTITY = "RECEIVE_USER_IDENTITY";
export const IDENTITY_SDK_FAILURE = "IDENTITY_SDK_FAILURE";
